import React, { PureComponent, Fragment } from "react";
import { DropdownButton, Dropdown } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import "./Navigation.css";
import { User } from "../../../types";
import Modal from "../../components/Modal";
import {
  Input,
  Form,
  Label,
  InputGroup,
  FormGroup,
  MenuWrapper,
} from "./styled";
import ErrorAlert from "../../components/error-alert/ErrorAlert";
import { CHANGE_PWD_SUCCESS_PATH } from "../../AppRoutes";

type NavigationProps = {
  requestLogout: () => any;
  user: User;
  requestChangePassword: (
    username: string,
    oldPassword: string,
    newPassword: string
  ) => Promise<any>;
  failureMessage: string;
  setFailureMessage: (message: string | null) => void;
  history: any;
  authenticatedWithKeycloak: boolean;
};

type NavigationState = {
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
  [x: number]: any;
  showPwdChangeDialog: boolean;
  pwdChangeSuccessful: boolean;
};

export class Navigation extends PureComponent<
  NavigationProps,
  NavigationState
> {
  state = {
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
    showPwdChangeDialog: false,
    pwdChangeSuccessful: false,
  };

  handleInputChange = (event: any) => {
    const { target } = event;
    this.setState({ [target.name]: event.target.value });
  };

  changePwd = () => {
    const { requestChangePassword, user, setFailureMessage } = this.props;
    const { oldPassword, newPassword, confirmNewPassword } = this.state;

    setFailureMessage("");
    if (newPassword === oldPassword) {
      setFailureMessage(
        "Your new password cannot be equal to your current password! Please try again."
      );
    } else if (newPassword !== confirmNewPassword) {
      setFailureMessage("Passwords do not match! Please try again.");
    } else if (newPassword === confirmNewPassword) {
      requestChangePassword(user.username, oldPassword, newPassword).then(() =>
        this.setState({ pwdChangeSuccessful: true })
      );
    } else {
      setFailureMessage(
        "Your password does not match the MPS password policy."
      );
    }
  };

  keyPressed = (event: any) => {
    if (event.key === "Enter") {
      this.changePwd();
    }
  };

  showPwdChangeDialog = () => {
    this.setState({
      showPwdChangeDialog: !this.state.showPwdChangeDialog,
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    });
    this.props.setFailureMessage(null);
  };

  render() {
    const { failureMessage, user, authenticatedWithKeycloak } = this.props;
    const {
      showPwdChangeDialog,
      oldPassword,
      newPassword,
      confirmNewPassword,
      pwdChangeSuccessful,
    } = this.state;

    if (pwdChangeSuccessful) {
      return <Redirect push to={CHANGE_PWD_SUCCESS_PATH} />;
    }

    return (
      <div className="navigation-wrapper">
        <div style={{ flex: "1 1 auto" }}>
          <img src="/mps-logo.png" width="200" alt="Morgan Project Services" />
        </div>
        <MenuWrapper>
          <DropdownButton
            alignRight
            variant="primary"
            id="dropdown-basic"
            title={<i className="fa fa-user fa-fw"></i>}
          >
            {user && user.username && (
              <Fragment>
                <div className="user-dropdown">{user.username}</div>
                <Dropdown.Divider />
              </Fragment>
            )}
            {!authenticatedWithKeycloak && (
              <Dropdown.Item onClick={() => this.showPwdChangeDialog()}>
                Change Password
              </Dropdown.Item>
            )}
            <Dropdown.Item onClick={this.props.requestLogout}>
              Logout
            </Dropdown.Item>
          </DropdownButton>
        </MenuWrapper>
        {showPwdChangeDialog && (
          <Modal
            title="Change Password"
            primaryActionLabel="Submit"
            secondaryActionLabel="Cancel"
            primaryAction={this.changePwd}
            secondaryAction={this.showPwdChangeDialog}
            width="600"
          >
            <Form autoComplete="off" style={{ fontSize: "1rem" }}>
              <div
                style={{
                  paddingBottom: "1.5rem",
                  fontSize: "1.125rem",
                  textAlign: "center",
                }}
              >
                After you changed your password you have to log in again.
              </div>
              {failureMessage && (
                <ErrorAlert lightMode>{failureMessage}</ErrorAlert>
              )}
              <FormGroup className="form-group">
                <InputGroup>
                  <Label className="col-sm-4 col-form-label">
                    OLD PASSWORD
                  </Label>
                  <Input
                    name="oldPassword"
                    type="password"
                    value={oldPassword}
                    aria-label="Password"
                    aria-describedby="password-icon"
                    required
                    autoFocus
                    onChange={this.handleInputChange}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup className="form-group">
                <InputGroup>
                  <Label className="col-sm-4 col-form-label">
                    NEW PASSWORD
                  </Label>
                  <Input
                    id="confirm-password-field"
                    name="newPassword"
                    type="password"
                    value={newPassword}
                    aria-label="NewPassword"
                    aria-describedby="password-icon"
                    required
                    onChange={this.handleInputChange}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup className="form-group">
                <InputGroup>
                  <Label className="col-sm-4 col-form-label">
                    CONFIRM NEW PASSWORD
                  </Label>
                  <Input
                    id="confirm-password-field"
                    name="confirmNewPassword"
                    type="password"
                    value={confirmNewPassword}
                    aria-label="ConfirmNewPassword"
                    aria-describedby="password-icon"
                    required
                    onChange={this.handleInputChange}
                    onKeyPress={this.keyPressed}
                  />
                </InputGroup>
              </FormGroup>
              <div
                style={{
                  fontSize: "0.9rem",
                  alignSelf: "center",
                  fontWeight: 300,
                  width: "80%",
                }}
              >
                For security reasons, your password must have a minimum length
                of <span style={{ fontWeight: "bold" }}>8 characters</span> and
                include at least{" "}
                <span style={{ fontWeight: "bold" }}>three of the four</span>{" "}
                available character types:
                <ul>
                  <li>one capital letter (A-Z)</li>
                  <li>one lowercase letter (a-z) </li>
                  <li>one digit (0-9)</li>
                  <li>one symbol (!,$,@ etc.)</li>
                </ul>
                It cannot include your username.
              </div>
            </Form>
          </Modal>
        )}
      </div>
    );
  }
}

export default Navigation;
